import { config } from 'Shared/Services/environment.service';

export const getGtmId = () => {
  return config('NX_NEXT_PUBLIC_GTM_ID');
};

export const getFacebookPixelId = () => {
  return config('NX_NEXT_PUBLIC_FACEBOOK_PIXEL_ID');
};
